<template>
  <CreateEditBidderPartnerModal
    v-if="showCreateEditBidderPartnerModal"
    :type="Number(bidderPartner.type)"
    :bidderPartnerId="bidderPartnerId"
    @closeModal="closeModal"
  />
  <AlterStatusBidderPartnerModal
    v-if="showAlterStatusBidderPartnerModal"
    :bidderPartnerId="bidderPartnerId"
    @closeModal="closeModal"
  />
  <DeleteBidderPartnerModal
    v-if="showDeleteBidderPartnerModal"
    :bidderPartnerId="bidderPartnerId"
    :typeName="textDetails"
    @closeModal="closeModalDeleteBidderPartner"
  />
  <LoadingData v-if="loadData" />
  <div v-else class="card">
    <div class="card-header d-flex align-items-center py-0">
      <h6 class="py-3 mb-0">Detalhes do {{ textDetails }}</h6>
      <div class="ms-auto">
        <button
          type="button"
          class="btn btn-sm btn-danger me-2"
          :title="`Excluir ${textDetails}`"
          @click="showDeleteBidderPartnerModal = true"
        >
          Excluir {{ textDetails }}
        </button>
        <button
          type="button"
          class="btn btn-sm btn-teal me-2"
          :title="`Alterar Status do ${textDetails}`"
          @click="showAlterStatusBidderPartnerModal = true"
        >
          Alterar Status
        </button>
        <button
          type="button"
          class="btn btn-sm btn-warning me-2"
          :title="`Editar ${textDetails}`"
          @click="showCreateEditBidderPartnerModal = true"
        >
          Editar {{ textDetails }}
        </button>
        <router-link
          :to="`/registries/${typeBidder ? 'bidders' : 'partners'}`"
          class="btn btn-sm btn-outline-dark"
          :title="`Listagem de ${textDetails}s`"
        >
          Listagem de {{ textDetails }}s
        </router-link>
      </div>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col-md-4 col-sm-12">
          <p><strong>Nome:</strong> {{ bidderPartner.name }}</p>
        </div>
        <div class="col-md-4 col-sm-12">
          <p><strong>CNPJ:</strong> {{ bidderPartner.cnpj }}</p>
        </div>
        <div class="col-md-4 col-sm-12">
          <p>
            <strong>Status: </strong>
            <span v-html="statusTranslate(bidderPartner.status)" />
          </p>
        </div>
        <div class="col-md-4 col-sm-12">
          <p>
            <strong>Endereço:</strong> {{ bidderPartner.address }},
            {{ bidderPartner.number }} - {{ bidderPartner.district }}
            {{
              bidderPartner.complement ? ` - ${bidderPartner.complement}` : ''
            }}
          </p>
        </div>
        <div class="col-md-4 col-sm-12">
          <p>
            <strong>Cidade/UF:</strong>
            {{ bidderPartner.city }}/{{ bidderPartner.uf }}
          </p>
        </div>
        <div class="col-md-4 col-sm-12">
          <p><strong>CEP:</strong> {{ bidderPartner.cep }}</p>
        </div>
        <div v-if="typePartner" class="col-md-4 col-sm-12">
          <p><strong>CNAE:</strong> {{ bidderPartner.cnae }}</p>
        </div>
        <div class="col-md-4 col-sm-12">
          <p><strong>E-mail:</strong> {{ bidderPartner.email }}</p>
        </div>
        <div class="col-md-4 col-sm-12">
          <p><strong>Telefone:</strong> {{ bidderPartner.phone }}</p>
        </div>
      </div>
    </div>
    <div class="card-footer">
      <ul class="list-inline text-muted mb-0">
        <li class="list-inline-item">
          Cadastro por:
          {{
            createdUpdatedUser(bidderPartner.createdBy, bidderPartner.createdAt)
          }}
        </li>
        <li class="list-inline-item">
          Atualizado por:
          {{
            createdUpdatedUser(bidderPartner.updatedBy, bidderPartner.updatedAt)
          }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import CreateEditBidderPartnerModal from '@/components/biddersPartners/CreateEditBidderPartnerModal.vue'
import AlterStatusBidderPartnerModal from '@/components/biddersPartners/AlterStatusBidderPartnerModal.vue'
import DeleteBidderPartnerModal from '@/components/biddersPartners/DeleteBidderPartnerModal.vue'
import LoadingData from '@/components/commons/LoadingData.vue'
import { createdUpdatedUser, statusTranslate } from '@/utils/strings'
import TypeBidderPartnerEnum from '@/enum/typeBidderPartnerEnum'

export default {
  name: 'DetailsPlan',

  components: {
    CreateEditBidderPartnerModal,
    AlterStatusBidderPartnerModal,
    DeleteBidderPartnerModal,
    LoadingData,
  },

  props: {
    bidderPartnerId: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      loadData: true,
      showCreateEditBidderPartnerModal: false,
      showAlterStatusBidderPartnerModal: false,
      showDeleteBidderPartnerModal: false,
      bidderPartner: {},
      createdUpdatedUser,
      statusTranslate,
    }
  },

  computed: {
    textDetails() {
      return this.typeBidder ? 'Proponente' : 'Parceiro'
    },

    typeBidder() {
      return Number(this.bidderPartner.type) === TypeBidderPartnerEnum.BIDDER
    },

    typePartner() {
      return Number(this.bidderPartner.type) === TypeBidderPartnerEnum.PARTNER
    },
  },

  methods: {
    async getBidderPartner() {
      try {
        this.bidderPartner = await this.$store.dispatch(
          'getBidderPartner',
          this.bidderPartnerId,
        )
        this.loadData = false
      } catch (error) {
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
      }
    },

    closeModal(loadBidderPartner) {
      if (loadBidderPartner) {
        this.getBidderPartner()
      }
      this.showCreateEditBidderPartnerModal = false
      this.showAlterStatusBidderPartnerModal = false
    },

    closeModalDeleteBidderPartner(deleted) {
      this.showDeleteBidderPartnerModal = false
      if (deleted) {
        if (this.typeBidder) {
          this.$router.push({
            name: 'RegistriesBidders',
          })
        } else {
          this.$router.push({
            name: 'RegistriesPartners',
          })
        }
      }
    },
  },

  mounted() {
    this.getBidderPartner()
  },
}
</script>
